import React, { useEffect } from 'react';
import { determineValueLabel, processNeedleValue } from './helper';
import styles from './view.module.css';

export const QueryRuleView = ({ data = {}, properties = [] }) => {
  const { needle } = data;
  const [property, setProperty] = React.useState('');

  useEffect(() => {
    setProperty(properties.find((prop) => prop.value === data.property)?.label);
  }, [data]);

  return (
    <div className={styles.wrapper}>
      <b>{property || data.property}</b> {determineValueLabel(data.datatype, data.rule)}{' '}
      <b>{processNeedleValue(data.datatype, data.rule, needle)}</b>
    </div>
  );
};
